import { useBoolean } from 'ahooks'
import { Flex, Typography } from 'antd'
import { useTheme } from 'antd-style'

import { UserEntity } from '@eastcoal/api/auth/interface'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { BindWechat } from '@eastcoal/auth/components/BindWechat'
import { useAuthStore, useAuthStoreApi } from '@eastcoal/auth/hooks/useStore'

export const Wechat = () => {
  const { user } = useAuthStore(state => pick(state, ['user']))

  const { setState } = useAuthStoreApi()

  const [open, openActions] = useBoolean(false)
  const { message } = useFeedback()

  const handleBindSuccess = (res: UserEntity) => {
    message.success('微信绑定成功')
    setState({ user: res })
    openActions.setFalse()
  }

  const theme = useTheme()

  return (
    <Flex gap={8}>
      <span>微信:</span>
      <span>
        {user.openId ? (
          <Typography.Text
            type='success'
            style={{
              fontSize: theme.fontSizeSM
            }}
          >
            已绑定
          </Typography.Text>
        ) : (
          <>
            <Typography.Link
              style={{
                fontSize: theme.fontSizeSM
              }}
              onClick={openActions.setTrue}
            >
              绑定
            </Typography.Link>
            <BindWechat
              open={open}
              onOpenChange={openActions.toggle}
              onSuccess={handleBindSuccess}
            />
          </>
        )}
      </span>
    </Flex>
  )
}
